/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */


import {
  Wrap,
  StyledPopoverFilter,
  StyledPopupFormColumn,
  StyledPopupHideAndConfigureLabel,  
} from './styles';

import Layer from 'services/models/Layer';
import geoAlert from 'services/utils/alert';
import { isBlank } from 'services/utils/checkers';
import geoConfirm from 'services/utils/confirm';
import { applyLabelSetting, getObjectRecreated } from 'services/utils/layerUtils';

import Filter from './components/Filter';
import FormColumn from './components/FormColumn';
import HideAndConfigureLabel from './components/HideAndConfigureLabel';
import MultiSelect from './components/MultiSelect';
import Table from './components/Table';
import FeatureCollection from './services/featureCollection';
import Operators from './services/operators';

import { CustomModalSaveAsLayer } from '../CustomModalSaveAsLayer';
import Mobile from '../Mobile';

import AppContext from 'views/MapView/services/context';

import Icon from '@map/components/Icons';
import { Divider, IconButton } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
import axios from 'axios';
/**
 * Tooltip é uma ferramenta utilizada para especificar informações extras
 * sobre algo quando o usuário move o ponteiro do mouse sobre um elemento.
 */
import Tooltip from 'components/Tooltip';
/**
 * useFormik é um hook personalizado do React que retornará
 * todos os estados e auxiliares do Formik diretamente.
 */
import { useFormik } from 'formik';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';
import { useSnackbar } from 'notistack';
/**
 * PropTypes é um mecanismo utilizado para garantir que os 
 * componentes usem o tipo de dados correto e passem os dados corretos
 */
import PropTypes from 'prop-types';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useContext usado para forcener uma maneira de passar dados
 * pela arvore de componentes sem ter que passar props manualmente
 * em todos os níveis.
 * 
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 * 
 * useRef permite que persista valores entre renderizações, ele pode
 * ser usado para armazenar um valor mutável que não causa uma nova
 * renderização quando atualizado e pode ser usado para acessar di-
 * retamente um elemento do DOM.
 * 
 * useMemo é um hook que retorna um valor memorizado.
 */
import {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
  useMemo,
} from 'react';
import { Waypoint } from 'react-waypoint';
import SliderColorPicker from 'views/MapView/components/SliderColorPicker';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useMap } from 'views/MapView/hooks';
import * as Yup from 'yup';

const layerFeatureCollection = new FeatureCollection();
const layerOperators = new Operators();

/**
 * Tabela de atributos, usada para exibição dos dados de uma camada, ou de multiplas camadas quando usado
 * em conjundo com a ferramenta de **Identificar feições**
 */
/**
 * AttributeTable
 * 
 * @param {*} param0 
 * @param {*} map
 * @param {function} removeThisLayer Responsavel por excluir a camada importada
 * @param {boolean} activeView
 * @param {boolean} dataTabs
 * @param {function} changeCursor Troca o cursor do mouse
 * @param {*} props Resto
 * 
 * @returns 
 */
export const AttributeTable = ({
  layer,
  map,
  removeThisLayer,
  activeView,
  dataTabs,
  changeCursor,
  ...props
}) => {  
  // TODO Mais um candidato a usar o useReducer
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElFormColumn, setAnchorElFormColumn] = useState(null);  
  const [anchorElHideAndConfigureLabel, setAnchorElHideAndConfigureLabel] = useState(null);  
  const [numberFeatures, setnumberFeatures] = useState(null);
  const [columns, setColumns] = useState(null);
  const [data, setData] = useState(null);
  const [operators, setOperators] = useState([]);
  // const [manualOperator, setManualOperator] = useState(null);
  const [page, setPage] = useState(1);
  const [geoJsonData, setGeoJsonData] = useState(null);
  const appContext = useContext(AppContext);
  const limit = 100;
  const limitForRequestAll = 1000;  
  const [hasNewInitialRequest, setHasNewInitialRequest] = useState(true);
  const [displayedColumns, setDisplayedColumns] = useState(null);
  const [filterColumn, setFilterColumn] = useState(null);
  const [filterOperator, setFilterOperator] = useState(null);
  const [filterValues, setFilterValues] = useState([]);
  const [sortColunm, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);
  const [shouldLoad, setShouldLoad] = useState(false);
  const [currentTab, setCurrentTab] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isShowInputCell, setIsShowInputCell] = useState(false);
  const [customColumnsType, setCustomColumnsType] = useState({});
  const [editColumn, setEditColumn] = useState(null);
  const [editColumnType, setEditColumnType] = useState(null);
  const [propInputCell, setPropInputCell] = useState({});
  const [selectedColumn, setSelectedColumn] = useState(null);
  const [selectedFontColor, setSelectedFontColor] = useState(false);
  const [selectedOutlineColor, setSelectedOutlineColor] = useState(false);
  const [selectedFontBold, setSelectedFontBold] = useState(false);
  const [selectedFontSize, setSelectedFontSize] = useState(14);
  const [selectedLabelAlign, setSelectedLabelAlign] = useState('center');
  const [highlightLineInEdit, setHighlightLineInEdit] = useState(false);
  const [resetFilter, setResetFilter] = useState(false);
  const [featureCollectionWfs, setFeatureCollectionWfs] = useState({});
  const [saveModalOpen, setSaveModalOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState();
  const [reloadSelectedTab, setReloadSelectedTab] = useState(false);
  const [filteredData, setFilteredData] = useState(null);
  const [isFiltered, setIsFiltered] = useState(false);
  const [selectedFeatures, setSelectedFeatures] = useState(layer?.selectedFeatures || []);
  const [refreshUpdatedFeatures, setRefreshUpdatedFeatures] = useState();

  const { setDialogMobileOpen } = appContext;
  const {
    layers,
    setLayers,
    setVisibilityLayer,
    changeSelectedLabelColumn,
    changeStatusLabelVisible,    
    changeLabelOpacity,
    addLayer,
    highlightSelectedFeature,
  } = useMap();
  const shiftKeyRef = useRef(null);
  const ctrlKeyRef = useRef(null);
  const idKey = 'ID_GBA';
  const notEditableColumns = ['bbox', 'ID_GBA', 'id', 'ID', 'Id', 'Área (m²)', 'Área (ha)', 'Comprimento (m)', 'Distância (m)', 'Distância (km)'];
  const columnsLengthArea = ['Área (m²)', 'Área (ha)', 'Comprimento (m)'];
  const arrPoints = useMemo(() => ['Point', 'MultiPoint'], []);
  const arrLines = useMemo(() => ["Line", "LineString", "MultiLineString"], []);
  const arrPolygons = useMemo(() => ["Polygon", "MultiPolygon", "Geometry", "GeometryCollection"], []);


  
  useEffect(() => {
    setRefreshUpdatedFeatures(!refreshUpdatedFeatures)
    if (isFiltered && layer?.selectedFeatures && layer?.selectedFeatures.length !== selectedFeatures.length) {
      // Desativa o isFiltered somente se o número de selectedFeatures mudar
      setIsFiltered(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layer?.selectedFeatures, isFiltered, selectedFeatures]);
  
  


  useEffect(() => {
    const areFeaturesEqual = (features1, features2) => {
      if (features1.length !== features2.length) return false;
  
      return features1.every((feature, index) => {
        return JSON.stringify(feature) === JSON.stringify(features2[index]);
      });
    };
  
    const updatedFeatures = (layer?.selectedFeatures || []).map((feature) => {
      if (!feature._feature) {
        return {
          ...feature,
        };
      }
      return feature; // Retorna o objeto original se já tiver _feature
    });
  
    if (!areFeaturesEqual(updatedFeatures, selectedFeatures)) {
      setSelectedFeatures(updatedFeatures);
    }
  }, [layer?.selectedFeatures, isFiltered, selectedFeatures, refreshUpdatedFeatures]);
  
  useEffect(() => {
    const filterData = () => {
      if (!layer) return; 
  
      const isInternalLayer = layer.type === 'interna';
      let newFilteredData = null;
  
      if (!isFiltered) {
        if (isInternalLayer) {
          newFilteredData = layer?.selectedFeatures;
        } else {
          newFilteredData = data
            ? data.filter((feature) =>
                selectedFeatures.some(
                  (filterFeature) =>
                    filterFeature.properties.ID_GBA === feature._feature.properties.ID_GBA
                )
              )
            : [];
  
          // Remover duplicados com base no ID_GBA
          if (newFilteredData) {
            newFilteredData = newFilteredData.filter((feature, index, self) =>
              index === self.findIndex((f) => f._feature.properties.ID_GBA === feature._feature.properties.ID_GBA)
            );
          }
        }
        setFilteredData(newFilteredData);
      }
    };
  
    filterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFeatures, isFiltered, layer, refreshUpdatedFeatures]);
  

  const { enqueueSnackbar } = useSnackbar();
  
  const formik = useFormik({
    initialValues: {
      layerName: '',
      layerStyle: null,
    },
    validationSchema: Yup.object().shape({
      layerName: Yup.string().required('Campo obrigatório'),
    }),
    onSubmit: (values) => {
      saveAsLayer(values.layerName, values.layerStyle);
      formik.resetForm();
    },
  });

  const { resetForm } = formik;

  /**
   * Salva a operação realizada em uma nova camada, que será lista no menu
   * @param {*} layerName Nome que deverá aparecer no menu
   * @param {*} layerStyle Estilo de como a camada deverá ser representada no mapa   
   */
  const saveAsLayer = useCallback((layerName, layerStyle) => {
    if (featureCollectionWfs) {      
      const customRender = L.canvas({ pane: 'mixedPane' });
      let options = {
        pane: 'mixedPane',
        renderer: customRender,
        style: layerStyle,
        pointToLayer: function (feature, latlng) {
          return L.circleMarker(latlng, {
            pane: 'mixedPane',
            ...layerStyle,
            renderer: customRender,
          });
        },
      };

      const geoJsonLayer = L.geoJSON(featureCollectionWfs, options);
      let layerToAdd = new Layer(
        null,
        'criada',
        null,
        layerName,
        null,
        null,
        null,
        null,
        null
      );
      layerToAdd.setLeafletLayer(geoJsonLayer);
      layerToAdd.setLayerStyle(layerStyle);

      let countIdFeature = 1;      
      layerToAdd.leafletLayer.eachLayer((feature) => {         
        let newFeatureProperties = {};
          newFeatureProperties.ID_GBA = countIdFeature;
          newFeatureProperties = {
            ...newFeatureProperties,
            ...feature.feature.properties,
            ID_GBA: countIdFeature,
          }  
        if (!arrPoints.includes(feature.feature.geometry.type)) {
          if (arrLines.includes(feature.feature.geometry.type)) {
            let lengthLine = turf.length(feature.feature, {
              units: 'meters',
            });
            newFeatureProperties[
              'Comprimento (m)'
            ] = lengthLine.toFixed(2);
            newFeatureProperties['Comprimento (m)'] = parseFloat(newFeatureProperties['Comprimento (m)']).toLocaleString('pt-BR');
          } else {
            newFeatureProperties['Área (m²)'] = turf
              .area(feature.feature)
              .toFixed(2);
            newFeatureProperties['Área (m²)'] = parseFloat(newFeatureProperties['Área (m²)']).toLocaleString('pt-BR');
            newFeatureProperties['Área (ha)'] = (turf
              .area(feature.feature)/10000)
              .toFixed(2);
            newFeatureProperties['Área (ha)'] = parseFloat(newFeatureProperties['Área (ha)']).toLocaleString('pt-BR');
          }
        }
        feature.feature.properties = newFeatureProperties;       
        
        countIdFeature++;
      });
      addLayer(layerToAdd);
      setSaveModalOpen(false);
    }
  }, [featureCollectionWfs, addLayer, arrPoints, arrLines]);

  /**
   * Reseta formik para estado inicial e fecha modal
   */
  const handleCloseSaveModal = useCallback(() => {
    resetForm();
    setSaveModalOpen(false);
  }, [resetForm]);

  /**
   * Método para aplicação dos filtros
   *
   * @param {array} columnLabel
   * @param {string} filterColumn
   * @param {array} filterValues
   */
  const onFilter = (displayedColumns, filterColumn, filterOperator, filterValues) => {
    setDisplayedColumns(displayedColumns);
    setFilterColumn(filterColumn);
    setFilterOperator(filterOperator);
    setFilterValues(filterValues);
    setShouldLoad(true);
  };

  /**
   * Método para aplicação do formulário de adição de coluna
   *
   * @param {string} columnLabel
   * @param {string} columnType
   * @param {string} oldColumnLabel
   */
  const onFormColumnSubmit = (columnLabel, columnType, oldColumnLabel) => {
    // Se recebeu oldColumnLabel como parametro, eh uma edição
    if (!columnExists(columnLabel)){
      if (oldColumnLabel) {
        setEditColumn(null);
        setEditColumnType(null);
        editColumnLabel(oldColumnLabel, columnLabel);
      } else {
        addColumn(columnLabel, columnType)
      }
    } else {
      enqueueSnackbar({ message: 'Coluna já existe', variant: 'warning' });
    }
  };

  /**
   * Método que recebe o submit do formulário de configuração dos rótulos
   *
   * @param {string} fontColor
   * @param {boolean} isFontBold
   * @param {string} fontSize
   * @param {string} alignLabel
   */
  const onFormConfigureLabel = (
    fontColor,
    outlineColor,
    isFontBold,
    fontSize,
    alignLabel
  ) => {
    let settingsLabel = {};
    let anySelectColumn = selectedColumn ? selectedColumn : layer.selectedLabelColumn;    
    setSelectedFontColor(fontColor);
    setSelectedOutlineColor(outlineColor);
    setSelectedFontBold(isFontBold);
    setSelectedFontSize(fontSize);
    setSelectedLabelAlign(alignLabel);    
    layer.setSettingsLabel({
      columnName: anySelectColumn.name,
      fontColor: fontColor,
      outlineColor: outlineColor,
      isFontBold: isFontBold,
      fontSize: fontSize,
      direction: alignLabel,
      opacity: 1,
    });    
    layer.leafletLayer.eachLayer((feature) => {
      settingsLabel = {
        columnName: anySelectColumn.name,
        feature: feature,
        fontColor: fontColor,
        outlineColor: outlineColor,
        isFontBold: isFontBold,
        fontSize: fontSize,
        direction: alignLabel,
        opacity: 1,
      };  
      applyLabelSetting(settingsLabel);
    });
    changeSelectedLabelColumn(layer.id, anySelectColumn);
    changeStatusLabelVisible(layer.id, true);
  };

  /**
   * Método para abertura do PopOver
   *
   * @param {object} event
   */
  const openPopOver = (event) => {
    setAnchorEl(event.currentTarget);
  };

  /**
   * Método para fechar o PopOver
   */
  const handleClosePopOver = () => {
    setAnchorEl(null);
  };

  /**
   * Método para abertura do popup do formulário de criação de colunas
   *
   * @param {object} event
   * @param {string} columnLabel
   * @param {string} columnType
   */
  const openPopupFormColumn = (event, columnLabel, columnType) => {
    setAnchorElFormColumn(event.currentTarget);
    columnLabel && setEditColumn(columnLabel);
    columnType && setEditColumnType(columnType);
  };

  /**
   * Método para abertura do popup do ocultação e configuração dos rótulos
   *
   * @param {object} event
   */
  const openPopupHideAndConfigureLabel = (event) => {
    setAnchorElHideAndConfigureLabel(event.currentTarget);
  }; 

  /**
   * Método para abertura de mensagem de confirmação
   * da exclusão dos registros selecionados
   */
  const openPopupConfirmRemove = () => {
    if (
      isEditableColumn(selectedColumn) &&
      ((selectedColumn && layer.dataType !== 'Text') || layer.selectedFeatures.length > 0)
    ) {
      let msg = '';
      let funcToCall = function () {};
      if (selectedColumn) {
        msg = 'Confirma a exclusão da coluna?';
        funcToCall = removeSelectedColumn;
      } else {
        let arrIdFeatureToRemove = layer.selectedFeatures.map((f) => {
          return f.properties.ID_GBA;
        });
        if (arrIdFeatureToRemove.length > 0) {
          if (arrIdFeatureToRemove.length === layer.getCountFeatures()) {
            msg =
              'A camada será excluída caso deseje remover todas as feições, deseja continuar?';
            funcToCall = removeThisLayer;
          } else {
            msg =
              'O sistema irá excluir a(s) feição(ões) relacionada(s). Deseja continuar?';
            funcToCall = removeSelectedFeatures;
          }
        }
      }
      geoConfirm({
        message: msg,
        callback: (confirmed) => {
          confirmed && funcToCall();
        },
      });
      setIsShowInputCell(false);
    }
  };

  /**
   * Método para fechar o popup do formulário de colunas
   */
  const handleClosePopupFormColumn = () => {
    setAnchorElFormColumn(null);
    setEditColumn(null);
    setEditColumnType(null);
  };

  /**
   * Método para fechar o popup de ocultar e configurar os rótulos
   */
   const handleClosePopupFormHideAndConfigureLabel = () => {
    setAnchorElHideAndConfigureLabel(null);
    setEditColumn(null);
    setEditColumnType(null);
  };

  /**
   * Método para ordenar alfabeticamente por atributo
   *
   * @param {string} attribute
   * @param {string} direction
   */
  const sortAlphabetically = (attribute, direction = 'asc') => (a, b) => {
    // a significa um item, b o seguinte
    // se um título está com a letra anterior da ordem alfabética do que a sua posterior comparada ele deve vir primeiro, por isso retorna -1
    if (`${a[attribute]}`.trim() < `${b[attribute]}`.trim()) {
      return direction.toLowerCase() === 'asc' ? -1 : 1;
    }
    // Se o título de a é maior que o de b, ou seja, vem depois no alfabeto, a deve ficar depois de b, por isso retorna 1
    if (`${a[attribute]}`.trim() > `${b[attribute]}`.trim()) {
      return direction.toLowerCase() === 'asc' ? 1 : -1;
    }
    // Se forem iguais, tanto faz
    return 0;
  };

  /**
   * Método para ordenar numericamente por atributo
   *
   * @param {string} attribute
   * @param {string} direction
   */
  const sortNumerically = (attribute, direction = 'asc') => (a, b) => {            
    if (direction !== 'asc') {
      return `${a[attribute]}` - `${b[attribute]}`;
    }

    return `${b[attribute]}` - `${a[attribute]}`;
  };

  /**
   * Retorna um array com as propriedades do objeto 
   * que possuem valor do tipo objeto
   *
   * @param {object} objProperties   
   */
  const getPropsWithValueTypeObject = (objProperties) => {
    let arrColumnsValueWithTypeObj = []
    Object.keys(objProperties).forEach((k) => {              
      if (typeof objProperties[k] === "object") {                
        arrColumnsValueWithTypeObj.push(k);
      }
    });
    return arrColumnsValueWithTypeObj;
  };  

  /**
   Método que retira pontos e vírgulas de números,
   para realizar operação de igualdade, 
   assim os números sempre estarão em formatos iguais antes da operação.   
  */
  const standardizeNumber = (number) => {
    // Convertendo o número para uma string e removendo os pontos e vírgulas
    return typeof(number) === "number" 
      ? (Number(number)).toString().replace(/[.,]/g, '')  
        : number.toString().replace(/[.,]/g, '')
  }

  /**
   Remove '.' e converte ',' em '.'   
  */
  const numberForAmericanStandard = (num) => {
    if (typeof num === 'number') return num;
    // Garante que valor estará em string para 
    // realizar os raplaces abaixo            
    num = num.toString();      
    num = num.replaceAll(".", "");    
    num = num.replaceAll(",", ".");            
    return Number(num);
  }

  /**
   * Método para o carregamento dos dados
   *
   * @param {boolean} initialLoad
   */
  const loadData = useCallback(
    (initialLoad = false, requestAllFeatures = true, newInitialRequest = false) => {
      let nextPage = page + 1;      
      let newGeoJsonData = [];
      
      /**
       * Obtém dos dados da tabela de atributos
       */
      const getDataAttributeTable = async (requestAllFeatures = true) => {
        // let dataAttributeTable = JSON.parse(sessionStorage.getItem('geobahia_' + layer.geoserverName));
        // if (dataAttributeTable) {
        //   return dataAttributeTable;
        // } 
        return layerFeatureCollection.get(layer.geoserverWorkspace, layer.geoserverName, requestAllFeatures)
          .then((fc) => {           
            setnumberFeatures(fc.totalFeatures)   
            return fc.attributes;
          });
        };        

      /**
       * Obtém os operadores dos campos da tabela de atributos
       */
      const getOperatorsAttributeTable = async () => {
        return layerOperators.get(layer.geoserverWorkspace, layer.geoserverName)
          .then((op) => {            
            return op.operators ? op.operators : [];
          });
      };      

      if (initialLoad) {
        nextPage = 1;
        setLoading(true);
      }      

      // Se camada do tipo "interna"
      if (layer && layer.type === 'interna' && layer.getService() === 'WMS') {        
        // Verifica se já existem dados carregados e não for carregamento inicial
        if (data && !newInitialRequest) {

          // APlica filtros, se houver                
          let defaultOperator = null;
          if (operators && operators.length && filterColumn) {
            defaultOperator = operators.find((o) => o.atributo === filterColumn).operador;                  
          } 
               
          // OBS.: Foi feito uma gambiarra para viabilizar o filtro apenas pelo ano nas camadas do HARPIA: 
          // se a coluna NÃO possuir o valor 'date' no meio da string, entao o opeador serla ILIKE
          let operator = defaultOperator 
                          ? defaultOperator === 'LIKE'
                            ? 'ILIKE'
                            : defaultOperator
                          : Array.isArray(filterValues)
                              ? 'IN'
                              : !isNaN(Number(filterValues)) && 
                              !filterColumn.includes('date') &&
                              !filterColumn.includes('dt') && 
                              !filterColumn.includes('data')
                                ? '=' 
                                : 'ILIKE';  
               
          let filtredFcAttributes =
            filterColumn && filterValues.length > 0
              ? geoJsonData.filter((v) => 
                  operator === 'IN'
                    ? filterValues.includes(`${v[filterColumn]}`)                     
                    : operator === '='
                      ? `${v[filterColumn]}` === `${Number(filterValues)}`                      
                      : !isNaN(Number(v[filterColumn]))
                        ? `${v[filterColumn]}`.includes(filterValues)                        
                        : `${v[filterColumn].toLowerCase()}`.includes(filterValues.toLowerCase())
                ) : geoJsonData;

          // Ordena por coluna
          filtredFcAttributes =
            sortColunm && sortDirection
              ? filtredFcAttributes.sort(
                filtredFcAttributes[0] && typeof filtredFcAttributes[0][`${sortColunm}`] === 'number' 
                  ? sortNumerically(sortColunm, sortDirection)
                  : sortAlphabetically(sortColunm, sortDirection)
                )
              : filtredFcAttributes;          
          
          if (initialLoad || data.length < filtredFcAttributes.length) {
            let newData = [];
            for (
              let i = initialLoad ? 0 : page * limit;
              i < nextPage * limit && i < filtredFcAttributes.length;
              i++
            ) {
              newData.push(filtredFcAttributes[i]);
            }
            if (initialLoad) {
              setData(newData);
            } else {
              newData.forEach((d) => {
                for (const key in d) {
                  if (typeof d[key] === 'object' && d[key] instanceof Date) {
                    d[key] = d[key].toLocaleDateString('pt-BR');
                  }
                }
              });
              setData((prevData) => [...prevData, ...newData]);
            }
            setPage(nextPage);
          }                 
          setLoading(false);
          
        } else {          
          // Verifica se existe dados no geoJsonData e não for carregamento incial
          if (geoJsonData && !newInitialRequest) {                    
            setDisplayedColumns(              
              Object.keys(geoJsonData[0]).filter(
                (c) => !['envelope', 'bbox'].includes(c)
              )
            );
            
            let newData = [];
            for (
              let i = initialLoad ? 0 : page * limit;
              i < nextPage * limit && i < geoJsonData.length;
              i++
            ) {
              newData.push(geoJsonData[i]);
            }            
            if (initialLoad) {
              setData(newData);
            } else {
              newData.forEach((d) => {
                for (const key in d) {
                  if (typeof d[key] === 'object' && d[key] instanceof Date) {
                    d[key] = d[key].toLocaleDateString('pt-BR');
                  }
                }
              });
              setData((prevData) => [...prevData, ...newData]);
            }
            setLoading(false);            
          } else {                                    
            // Requisita dados na API
            getDataAttributeTable(requestAllFeatures)
            .then((newGeoJsonData) => {
              if (newGeoJsonData && newGeoJsonData.length > 0) {
                                
                // Verifica se camada foi configurada como "Alto volume de dados" e então salva na sessioStorage
                // if (layer.additionalProps.layerSize && layer.additionalProps.layerSize === '1') {                
                //   sessionStorage.setItem('geobahia_' + layer.geoserverName, JSON.stringify(newGeoJsonData));
                // }
              
                // APlica filtros, se houver                
                let defaultOperator = null;
                if (operators && operators.length && filterColumn) {
                  defaultOperator = operators.find((o) => o.atributo === filterColumn).operador;                  
                }        
                
                // OBS.: Foi feito uma gambiarra para viabilizar o filtro apenas pelo ano nas camadas do HARPIA: 
                // se a coluna NÃO possuir o valor 'date' no meio da string, entao o opeador serla ILIKE
                let operator = defaultOperator 
                                ? defaultOperator === 'LIKE'
                                  ? 'ILIKE'
                                  : defaultOperator
                                : Array.isArray(filterValues)
                                    ? 'IN'
                                    : !isNaN(Number(filterValues)) && 
                                    !filterColumn.includes('date') &&
                                    !filterColumn.includes('dt') && 
                                    !filterColumn.includes('data')
                                      ? '=' 
                                      : 'ILIKE';                
                
                let filtredFcAttributes =
                  filterColumn && filterValues.length > 0
                    ? newGeoJsonData.filter((v) => 
                        operator === 'IN'
                          ? filterValues.includes(`${v[filterColumn]}`)                           
                          : operator === '='
                            ? `${v[filterColumn]}` === `${Number(filterValues)}`                            
                            : !isNaN(Number(v[filterColumn]))
                              ? `${v[filterColumn]}`.includes(filterValues)
                              : `${v[filterColumn].toLowerCase()}`.includes(filterValues.toLowerCase())
                      ) : newGeoJsonData;                

                // Ordena por coluna
                filtredFcAttributes =
                sortColunm && sortDirection
                  ? filtredFcAttributes.sort(
                    typeof filtredFcAttributes[0][`${sortColunm}`] === 'number' 
                      ? sortNumerically(sortColunm, sortDirection)
                      : sortAlphabetically(sortColunm, sortDirection)
                    )
                  : filtredFcAttributes;

                // Define colunas a serem exibidas na tabela de atributos
                initialLoad &&
                  !displayedColumns &&
                  setDisplayedColumns(
                    // Object.keys(fc.attributes[0]).filter(
                    Object.keys(newGeoJsonData[0]).filter(
                      (c) => !['envelope', 'bbox'].includes(c)
                    )
                  );

                setGeoJsonData(newGeoJsonData);
                if (initialLoad || data.length < filtredFcAttributes.length) {
                  let newData = [];
                  for (
                    let i = initialLoad ? 0 : page * limit;
                    i < nextPage * limit && i < filtredFcAttributes.length;
                    i++
                  ) {
                    newData.push(filtredFcAttributes[i]);
                  }                  
                  if (initialLoad) {
                    setData(newData);
                  } else {
                    newData.forEach((d) => {
                      for (const key in d) {
                        if (typeof d[key] === 'object' && d[key] instanceof Date) {
                          d[key] = d[key].toLocaleDateString('pt-BR');
                        }
                      }
                    });
                    setData((prevData) => [...prevData, ...newData]);
                  }
                }                
                setPage(nextPage);

              } else {
                initialLoad && setData([]);
              }  
              
            })
            .then(() => {              
              // Requisita operadores utilizados filtro
              return getOperatorsAttributeTable();
            })
            .then((op) => {
              setOperators(op);              
            })
            .catch((error) => {
              console.error(error);
              setOperators([]);
            })
            .finally(() => {   
              setLoading(false);
            });
          }          
        }
      } else if (
        (layer &&
          (['importada', 'criada'].includes(layer.type) ||
            layer.getService() === 'WFS')) ||
        (dataTabs && currentTab !== null)
      ) {  
        
        // Veifica se pode manter registro
        const filterRegister = (operator, fieldValue, filterValues) => {

          let valueRegisterToCompare = numberForAmericanStandard(fieldValue);
          let valueFilterToCompare = numberForAmericanStandard(filterValues);

          switch (operator) {                    
            case '=':                      
              return !isNaN(valueRegisterToCompare)
                        ? valueRegisterToCompare === valueFilterToCompare
                        : `${fieldValue}` === `${filterValues}`;                    
            case '!==':
              return isNaN(valueRegisterToCompare) || isNaN(valueFilterToCompare)
                        ? `${fieldValue}` !== `${filterValues}`
                        : valueRegisterToCompare !== valueFilterToCompare;
            case '<':
              return valueRegisterToCompare < valueFilterToCompare;
            case '<=':
              return valueRegisterToCompare <= valueFilterToCompare;
            case '>':
              return valueRegisterToCompare > valueFilterToCompare;
            case '>=':
              return valueRegisterToCompare >= valueFilterToCompare;
            default: //ILIKE
              return !isNaN(Number(fieldValue))
                ? standardizeNumber(fieldValue).includes(standardizeNumber(filterValues))
                : `${fieldValue.toLowerCase()}`.includes(filterValues.toLowerCase());                   
          }          
        }
        
        if (initialLoad) {
          if (layer && layer.leafletLayer) {            
            if(layer.leafletLayer._layers) {
              let firstLayer = layer.leafletLayer._layers[Object.keys(layer.leafletLayer._layers)[0]];
              if(firstLayer && firstLayer.feature && firstLayer.feature.properties){
                let objProperties = firstLayer.feature.properties;
                let arrColumnsValueWithTypeObj = getPropsWithValueTypeObject(objProperties);                
                layer.leafletLayer.eachLayer((feature) => {
                  if (
                    feature.feature.properties &&
                    Object.keys(feature.feature.properties).length
                  ) {
                    let featureProperties = feature.feature.properties;                    
                    for (let col of arrColumnsValueWithTypeObj) {
                      featureProperties[col] = String(featureProperties[col]);
                    }
    
                    newGeoJsonData.push({
                      ...featureProperties,
                      bbox: feature.getBounds
                        ? feature.getBounds()
                        : feature.getLatLng(),
                      _feature: feature.feature,
                    });
                  }
    
                  if (
                    feature.feature.columnsType &&
                    Object.keys(feature.feature.columnsType).length
                  ) {
                    // Seta as colunas customizadas (Criadas pelo usuário)
                    setCustomColumnsType(feature.feature.columnsType);
                  }
    
                  if (
                    feature._tooltip?.options &&
                    Object.keys(feature._tooltip.options).length
                  ) {
                    feature._tooltip.options.fontColor &&
                      setSelectedFontColor(feature._tooltip.options.fontColor);
                    feature._tooltip.options.outlineColor &&
                      setSelectedOutlineColor(
                        feature._tooltip.options.outlineColor
                      );
                    feature._tooltip.options.isFontBold &&
                      setSelectedFontBold(feature._tooltip.options.isFontBold);
                    feature._tooltip.options.fontSize &&
                      setSelectedFontSize(feature._tooltip.options.fontSize);
                    feature._tooltip.options.direction &&
                      setSelectedLabelAlign(feature._tooltip.options.direction);
                  }
                });
              }
            }
          } else {
            newGeoJsonData = dataTabs.length
              ? dataTabs[currentTab].featureInfo
              : [];
            changeCursor &&
              changeCursor(
                newGeoJsonData && newGeoJsonData.length ? 'blue' : 'orange'
              );
          }
          setnumberFeatures(newGeoJsonData?.length)

          
          // Filtrando os dados
          let defaultOperator = filterOperator;
          if (!defaultOperator && operators && operators.length && filterColumn) {
            defaultOperator = operators.find((o) => o.atributo === filterColumn).operador;                  
          }              
          
          // OBS.: Foi feito uma gambiarra para viabilizar o filtro apenas pelo ano nas camadas do HARPIA: 
          // se a coluna NÃO possuir o valor 'date' no meio da string, entao o opeador serla ILIKE
          let operator = defaultOperator 
                          ? defaultOperator === 'LIKE'
                            ? 'ILIKE'
                            : defaultOperator
                          : Array.isArray(filterValues)
                              ? 'IN'
                              : !isNaN(Number(filterValues)) && 
                              !filterColumn.includes('date') &&
                              !filterColumn.includes('dt') && 
                              !filterColumn.includes('data')
                                ? '=' 
                                : 'ILIKE';           
          
          newGeoJsonData =
            filterColumn && filterValues.length > 0
              ? newGeoJsonData.filter((gData) => filterRegister(operator, gData[filterColumn], filterValues)) 
              : newGeoJsonData;
          //Ordenando os dados
          newGeoJsonData =
            sortColunm && sortDirection
              ? newGeoJsonData.sort(
                  sortAlphabetically(sortColunm, sortDirection)
                )
              : newGeoJsonData;
                    
          setGeoJsonData(newGeoJsonData);
        }
        let gJsonData = initialLoad ? newGeoJsonData || [] : geoJsonData;
        if (initialLoad || data.length < gJsonData.length) {
          let newData = [];
          for (
            let i = initialLoad ? 0 : page * limit;
            i < nextPage * limit && i < gJsonData.length;
            i++
          ) {
            newData.push(gJsonData[i]);
          }
          if (initialLoad) {
            
            setData(newData);
          } else {
            newData.forEach((d) => {
              for (const key in d) {
                if (typeof d[key] === 'object' && d[key] instanceof Date) {
                  d[key] = d[key].toLocaleDateString('pt-BR');
                }
              }
            });

            setData((prevData) => [...prevData, ...newData]);
          }
          initialLoad &&
            !displayedColumns &&
            newData.length > 0 &&
            setDisplayedColumns(
              Object.keys(newData[0]).filter(
                (c) => !['envelope', 'bbox'].includes(c)
              )
            );
          setPage(nextPage);
        }
        setLoading(false);
      }
    },
    [
      data,
      filterColumn,
      filterValues,
      geoJsonData,
      layer,
      page,
      sortColunm,
      sortDirection,
      displayedColumns,
      currentTab,
      dataTabs,
      changeCursor,
      operators, 
      filterOperator
    ]
  );

  /**
   * Obtém os valores a serem exibidos no campo "Valor/Feição" do filtro
   */
  const getDistinctValues = async (attribute) => {
    let distincValues = [];
    let attributes = [];
    let originGeoJson = [];

    if (layer && layer.type === 'interna' && layer.getService() === 'WMS') {
      originGeoJson = geoJsonData;
    } else if (
      (layer &&
        (['importada', 'criada'].includes(layer.type) ||
          layer.getService() === 'WFS')) ||
      (dataTabs && currentTab !== null)
    ) {
      if (layer) {
        layer.leafletLayer.eachLayer((feature) =>
          originGeoJson.push({
            ...feature.feature.properties,
            bbox: feature.getBounds ? feature.getBounds() : feature.getLatLng(),
          })
        );
      } else {
        originGeoJson = dataTabs[currentTab].featureInfo || [];
      }
    }
    originGeoJson.forEach(
      (gjData) =>
        !attributes.includes(gjData[attribute]) &&
        attributes.push(gjData[attribute])
    );
    if (attributes && attributes.length > 0) {
      distincValues = attributes.map((v) => ({ [attribute]: v }));
    }  

    return distincValues;
  };

  /**
   * Verifica se nova coluna deve ser adicionada 
   * no final da tabela de atributos
   */
  const shouldAddColumnsOnEndTable = () => {
    return layer.type === 'criada'
      ? arrPoints.includes(layer.dataType)
      : true;
  };

  /**
   * Verifica se a coluna existe
   */
  const columnExists = (name) => {
    return columns.some(function (el) {
      return el.name === name;
    });
  };  

  /**
   * Método para adicionar coluna na tabela
   * de atributos da camada
   *
   * @param {string} columnLabel
   * @param {string} columnType
   */
  const addColumn = (columnLabel, columnType) => {
    // Verifica se coluna deve ser adicionada no meio da tabela
    if (!shouldAddColumnsOnEndTable()) {
      var nameColumnAreaOrLength = null;
      Object.keys(data[0]).forEach((c) => {
        // Obtém o nome da coluna que armazena a área/comprimento da feição
        if (columnsLengthArea.includes(c)) nameColumnAreaOrLength = c;
      });
    }
    // Percorre feição a feição
    layer.leafletLayer.eachLayer((feature) => {
      // Verifica se coluna deve ser adicionada ao fim da tabela
      if (shouldAddColumnsOnEndTable()) {
        // Adiciona nova coluna
        feature.feature.properties[columnLabel] = '';        
      } else {        
        // Copia propriedades da feature
        let objCopyProperties = Object.assign(feature.feature.properties);
        // Obtém o valor da área/comprimento da feição
        let valueColumnAreaOrLength =
          feature.feature.properties[nameColumnAreaOrLength];        
        // Remove propriedade do objeto cópia
        delete objCopyProperties[nameColumnAreaOrLength];
        // Adiciona nova coluna
        objCopyProperties[columnLabel] = '';
        // Readiciona coluna de área/comprimento com seu respectivo valor
        objCopyProperties[nameColumnAreaOrLength] = valueColumnAreaOrLength;
        // Adiciona proriedades a feição
        feature.feature.properties = Object.assign(objCopyProperties);
      }
      // Cria um novo objeto columnsType propriedade na feição
      feature.feature.columnsType = feature.feature.columnsType || {};
      // Adiciona key/value ao objeto columnsType
      feature.feature.columnsType[columnLabel] = columnType;
      setCustomColumnsType(feature.feature.columnsType);
    });
    // Adiciona nova coluna no array de colunas
    // que podem ser exibidas
    displayedColumns.push(columnLabel);    
    setDisplayedColumns(displayedColumns);
    setShouldLoad(true);
  };

  /**
   * Método para editar uma coluna na
   * tabela de atributos da camada
   *
   * @param {string} oldColumnLabel
   * @param {string} newColumnLabel
   */
  const editColumnLabel = (oldColumnLabel, newColumnLabel) => {
    // Verifica se o nome da coluna sofreu alteração
    if (oldColumnLabel !== newColumnLabel) {
      // Adiciona valor na coluna do respectivo registro
      layer.leafletLayer.eachLayer((feature) => {
        let properties = feature.feature.properties;
        let columnsType = feature.feature.columnsType;
        if (
          properties &&
          Object.keys(properties).length &&
          oldColumnLabel in properties
        ) {
          let finalProperties = {};
          Object.keys(properties).forEach((c) => {
            if (c === oldColumnLabel) {
              finalProperties[newColumnLabel] = properties[c];
            } else {
              finalProperties[c] = properties[c];
            }
          });
          feature.feature.properties = Object.assign(finalProperties);
        }
        if (
          columnsType &&
          Object.keys(columnsType).length &&
          oldColumnLabel in columnsType
        ) {
          let finalColumnType = {};
          Object.keys(columnsType).forEach((c) => {
            if (c === oldColumnLabel) {
              finalColumnType[newColumnLabel] = columnsType[c];
            } else {
              finalColumnType[c] = columnsType[c];
            }
          });
          feature.feature.columnsType = Object.assign(finalColumnType);
        }
        if (
          oldColumnLabel === layer.selectedLabelColumn?.name &&
          feature._tooltip?.options &&
          Object.keys(feature._tooltip.options).length
        ) {
          changeLabelOpacity(layer, layer.statusLabelVisibility ? 1 : 0);
          changeSelectedLabelColumn(layer.id, {
            ...layer.selectedLabelColumn,
            name: newColumnLabel,
            label: newColumnLabel,
          });
        }
      });
      // Substitui antiga coluna pela nova, mantendo mesma posição
      let indexOldColumn = displayedColumns.indexOf(oldColumnLabel);
      displayedColumns.splice(indexOldColumn, 1, newColumnLabel);
      setDisplayedColumns(displayedColumns);
      setShouldLoad(true);
    }
  };

  
  /**
   * Método para limpar a seleção de feições
   */
  const clearSelectedFeatures = () => {
    return (layer.selectedFeatures = []);
  };

  /**
   * Método para limpar a seleção de feições importada, criada e interna
   * do mapa e da tabela de atributos
   */
  const clearFeatureHighlights = () => {
    layer.setSelectedFeatures(
      [],
      null,
      ctrlKeyRef.current,
      shiftKeyRef.current,
      true
    );  
    highlightSelectedFeature(layer)
    .finally(() => {
      setLoading(false);
      setShouldLoad(true);
    })
    .catch((error) => {
      console.error('Erro ao limpar a seleção de feições:', error);
      setLoading(false);
    });

  };


  /**
   * Método para remover feições selecionadas da camada
   */
  const removeSelectedFeatures = () => {
    let selectedFeatures = layer.selectedFeatures;    
    let arrIdFeatureToRemove = selectedFeatures.map((f) => {      
      return f.properties[idKey];
    });
    layer.leafletLayer.eachLayer((feature) => {
      if (
        feature.feature.properties &&
        Object.keys(feature.feature.properties).length &&
        arrIdFeatureToRemove.includes(feature.feature.properties[idKey])
      ) {
        layer.leafletLayer.removeLayer(feature);
      }
    });
    // Limpa a(s) feição(es) selecionada(s)
    clearSelectedFeatures();
    setShouldLoad(true);
    enqueueSnackbar({ message: 'Registro(s) excluído(s)', variant: 'success' });
  };

  /**
   * Método para remover coluna
   */
  const removeSelectedColumn = () => {
    layer.leafletLayer.eachLayer((feature) => {
      let properties = feature.feature.properties;
      let columnsType = feature.feature.columnsType;
      let selectedColumnName = selectedColumn.name;
      if (
        properties &&
        Object.keys(properties).length &&
        selectedColumnName in properties
      ) {
        let finalProperties = {};
        Object.keys(properties).forEach((c) => {
          if (c !== selectedColumnName) finalProperties[c] = properties[c];
        });
        feature.feature.properties = Object.assign(finalProperties);
      }
      if (
        columnsType &&
        Object.keys(columnsType).length &&
        selectedColumnName in columnsType
      ) {
        let finalColumnType = {};
        Object.keys(columnsType).forEach((c) => {
          if (c !== selectedColumnName) finalColumnType[c] = columnsType[c];
        });
        feature.feature.columnsType = Object.assign(finalColumnType);
      }
    });
    // Sendo a coluna seleciona a mesma do rótulo, oculta o rótulo
    if (layer.selectedLabelColumn?.name === selectedColumn.name) {
      changeLabelOpacity(layer, 0);
      changeSelectedLabelColumn(layer.id, null);
      changeStatusLabelVisible(layer.id, true);
    }
    setSelectedColumn(null);
    setShouldLoad(true);
    enqueueSnackbar({ message: 'Coluna excluída', variant: 'success' });
  };

  /**
   * Método que verifica se a coluna é 'editável'
   *
   * @param {object} column
   */
  const isEditableColumn = (column) => {
    return notEditableColumns.includes(column?.name) ? false : true;
  };

  /**
   * Atualiza propriedades da célula ativa
   *
   * @param {object} event
   * @param {object} row
   * @param {object} column
   */
  const changeCell = (event, row, column) => {
    setPropInputCell({ event: event, row: row, column: column });
  };

  /**
   * Inicia procedimento para persistência do
   * valor da célula ativa
   *
   */
  const saveInputCell = () => {
    if (propInputCell.event && propInputCell.row && propInputCell.column) {
      validation(propInputCell.event, propInputCell.row, propInputCell.column);      
    } else {
      setIsShowInputCell(false);      
    }
    setHighlightLineInEdit(false);
  };

  /**
   * Realiza validação do valor conforme
   * o tipo da coluna ao qual pertence
   *
   * @param {object} e
   * @param {object} row
   * @param {object} column
   */
  const validation = (e, row, column) => {
    let date_regex = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/[0-9]{4}/;          
    if (customColumnsType[column.name] === 'date') {
      if (!isBlank(e.target.value)) {
        date_regex.test(e.target.value) 
        ? persistValueInputCell(e, row, column) 
        : invalidateDateInput(e.target);
      }
    }else{
      persistValueInputCell(e, row, column);
    }
  };

  /**
   * Invalida campo input
   *
   * @param {object} target
   */
  const invalidateDateInput = (target) => {
    target.style.color = 'red';
    enqueueSnackbar({ message: 'Campo data inválido!', variant: 'error' });
  };

  /**
   * Persiste valor na "tabela de atributos" da camada
   *
   * @param {object} e
   * @param {object} row
   * @param {object} column
   */
  const persistValueInputCell = (event, row, column) => {        
    let target = event.target;    
    // Adiciona valor na coluna do respectivo registro
    layer.leafletLayer.eachLayer((feature) => {
      let properties = feature.feature.properties;
      if (
        properties &&
        Object.keys(properties).length && (idKey in row && properties.ID_GBA === row.ID_GBA)       
      ) {        
        properties[column.name] = target.value;
        if (
          (feature._tooltip?.options && Object.keys(feature._tooltip.options).length) ||
          layer.dataType === 'Text'
        ) {          
          let settingsLabel = {
            columnName: column.name,
            feature: feature,
            fontColor: selectedFontColor,
            isFontBold: selectedFontBold,
            fontSize: selectedFontSize,
            direction: selectedLabelAlign,
            opacity: layer.statusLabelVisibility ? 1 : 0,
          };
          applyLabelSetting(settingsLabel);
        } 
      }
    });
    setIsShowInputCell(false);    
    setShouldLoad(true);
    if (column.name === layer.classColumn) {
      layer.updateFeaturesStyle(layer.classColumn, layer.colorScale);
    }    
  };

  /**
   * Limpa todos os dado carregados
   */
  const clearAllData = () => {
    setDisplayedColumns(null);
    setFilterColumn(null);
    setFilterOperator(null);
    setFilterValues([]);
    setSortColumn(null);
    setSortDirection(null);
    setShouldLoad(true);
    setColumns(null);
    setData(null);
    setPage(1);  
    setResetFilter(true);
  };

  const getVetorialFeatures = async () => {
    /**
     * Obtém feições selecionadas de camadas do tipo 'interna' (WMS)
     * no formato vetorial (WFS)
     */
    // fazer a mesma chama para dataTabs
  
    if (['interna', 'importada', 'criada'].includes(layer?.type)) {
      let arrGid = layer.selectedFeatures.map((f) => f.gid);
      let varOperation;
      let arrFeatures = [];
      // Obtém feições selecionadas
      try {
        if (layer?.type === 'interna') {
          let response = await axios(
            `${layer.getFullServiceLink('WFS', null, false)}featureID=${arrGid.toString()}`
          );
          varOperation = response.data;
        } else {
          layer.selectedFeatures.map((item) => {
            let objectRecreated = getObjectRecreated(item);
            arrFeatures.push(objectRecreated);
            return arrFeatures;
          });
          varOperation = turf.featureCollection(arrFeatures);
        }
  
        setFeatureCollectionWfs(varOperation);
        setSaveModalOpen(true);
      } catch (err) {
        geoAlert({
          message: 'Não foi possível obter feição(es) vetorial(is) da camada.',
        });
      }
    } else if (
      !layer &&
      dataTabs?.length > 0 &&
      dataTabs[currentTab]?.layer &&
      dataTabs[currentTab].layer.selectedFeatures?.length > 0
    ) {
      let arrGid = dataTabs[currentTab].layer.selectedFeatures.map((f) => f.gid);
      let varOperation;
      let arrFeatures = [];
      // Obtém feições selecionadas
      try {
        if (dataTabs[currentTab].layer?.type === 'interna') {
          let response = await axios(
            `${dataTabs[currentTab].layer.getFullServiceLink('WFS', null, false)}featureID=${arrGid.toString()}`
          );
          varOperation = response.data;
        }
        if (dataTabs[currentTab].layer?.type === 'criada' || dataTabs[currentTab].layer?.type === 'importada') {
          dataTabs[currentTab].layer.selectedFeatures.map((item) => {
            let objectRecreated = getObjectRecreated(item);
            arrFeatures.push(objectRecreated);
            return arrFeatures;
          });
          varOperation = turf.featureCollection(arrFeatures);
        }
  
        setFeatureCollectionWfs(varOperation);
        setSaveModalOpen(true);
      } catch (err) {
        geoAlert({
          message: 'Não foi possível obter feição(es) vetorial(is) da camada.',
        });
      }
    }
  };

  useEffect(() => {
    if (resetFilter && layer) {        
      setResetFilter(false);
      // layer.setVisible(true);      
      layer.leafletLayer.remove();
      layer.loadLayer(map);
      setVisibilityLayer(layer.id, true);       
      let settingsLabel = {};
      if (layer.selectedLabelColumn?.name && layer.statusLabelVisibility) {
        layer.leafletLayer.eachLayer((feature) => {          
          settingsLabel = {
            columnName: layer.selectedLabelColumn.name,
            feature: feature,
            fontColor: selectedFontColor,
            outlineColor: selectedOutlineColor,
            isFontBold: selectedFontBold,
            fontSize: selectedFontSize,
            direction: selectedLabelAlign,
            opacity: 1,
          };
          applyLabelSetting(settingsLabel);                
        });   
      } 
    }
  }, [
    resetFilter,
    layer,
    map,
    setVisibilityLayer,
    selectedFontColor,
    selectedOutlineColor,
    selectedFontBold,
    selectedFontSize,
    selectedLabelAlign
  ]);

  useEffect(() => {
    // Verifica se camada foi configurada como "Alto volume de dados" para 
    // realizar primeira requisição com quantidade limitada de registros    
    let requestAllFeatures = true;
    if (layer?.additionalProps.layerSize && layer?.additionalProps.layerSize === '1') {      
      requestAllFeatures = false;      
    }
    loadData(true, requestAllFeatures);    
    //Passado array de dependências vazio para que o codigo execute apenas uma vez
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    //if ((sortColunm && sortDirection) || (filterColumn && filterValues))
    if (shouldLoad) {      
      let requestAllFeatures = true;
      let newInitialRequest = false;
      // Verifica se camada foi configurada como 'Alto volume de dados' 
      // ,se o scrolling chegou no valor definido na variavel limitForRequestAll
      // e se não foi realizada requisição de todas as features
      if (
        layer?.additionalProps.layerSize 
          && layer?.additionalProps.layerSize === '1'           
          && hasNewInitialRequest 
          && (filterValues.length > 0 || sortColunm)
      ) {          
          // requestAllFeatures = false;
          // setRequestAllFeatures(true);
          newInitialRequest = true;
          setHasNewInitialRequest(false);
      }     
      loadData(true, requestAllFeatures, newInitialRequest); 
      // loadData(true);
      setShouldLoad(false);
    }
  }, [
    loadData,
    shouldLoad,
    layer?.additionalProps.layerSize,
    hasNewInitialRequest,
    filterValues.length,
    sortColunm
  ]);

  //Aplicando filtros no Mapa
  useEffect(() => {    

    // Verifica se pode ocultar a feição
    const checkCanHideFeature = (operator, valueFeature, valueFilter) => {
      
      let valueFeatureToCompare = numberForAmericanStandard(valueFeature);
      let valueFilterToCompare = numberForAmericanStandard(valueFilter);      

      // Verifica se operador selecionado (exceto o '=') é para 
      // valores numéricos e se os valores envolvidos não são números
      if (['!==', '<', '<=', '>', '>='].includes(operator) &&
          (isNaN(valueFeatureToCompare) ||  isNaN(valueFilterToCompare))
      ) {
          if (operator === '!==') {
            return valueFeature === valueFilter
          }
          return true;
      } else {
        switch (operator) {                                        
          case '=':
            return !isNaN(valueFeatureToCompare)
                      ? valueFeatureToCompare !== valueFilterToCompare
                      : `${valueFeature}` !== `${valueFilter}`;
          case '!==':
            return valueFeatureToCompare === valueFilterToCompare            
          case '<':
            return valueFeatureToCompare >= valueFilterToCompare            
          case '<=':
            return valueFeatureToCompare > valueFilterToCompare            
          case '>':
            return valueFeatureToCompare <= valueFilterToCompare            
          case '>=':
            return valueFeatureToCompare < valueFilterToCompare            
          default://ILIKE
            return !isNaN(valueFeatureToCompare)
                      ? !valueFeatureToCompare.toString().includes(valueFilterToCompare.toString())
                      : !`${valueFeature.toLowerCase()}`.includes(valueFilter.toLowerCase())      
        }
      }
    }

    if (filterColumn && filterOperator && filterValues) {     

      // Define o operador     
      // let defaultOperator = manualOperator;
      // if (!defaultOperator && operators && operators.length && filterColumn) {
      //   defaultOperator = operators.find((o) => o.atributo === filterColumn).operador;                  
      // }                
      let defaultOperator = null;
      if (operators && operators.length && filterColumn) {
        defaultOperator = operators.find((o) => o.atributo === filterColumn).operador;                  
      }    

      // OBS.: Foi feito uma gambiarra para viabilizar o filtro apenas pelo ano nas camadas do HARPIA: 
      // se a coluna NÃO possuir o valor 'date' no meio da string, entao o opeador serla ILIKE
      let operator = defaultOperator 
                      ? defaultOperator === 'LIKE'
                        ? 'ILIKE'
                        : defaultOperator
                      : Array.isArray(filterValues)
                          ? 'IN'
                          : !isNaN(Number(filterValues)) && 
                          !filterColumn.includes('date') &&
                          !filterColumn.includes('dt') && 
                          !filterColumn.includes('data')
                            ? '=' 
                            : 'ILIKE';  
      
      // Aplicando filtro no mapa em camadas WMS
      if (layer && layer.type === 'interna' && layer.getService() === 'WMS') {        
        layer.leafletLayer.remove();

        const filter = `"${filterColumn}" ${operator} ${
          Array.isArray(filterValues)
            ? "('" + filterValues.join("','") + "')"
            : operator === '='
              ? filterValues
              : "'%" + filterValues + "%'"
        }`

        layer.loadLayer(map, filter);

        setVisibilityLayer(layer.id, true);
        // Retorna função de reset no filter
        return () => {          
          // layer.leafletLayer.setParams({
          //   cql_filter: 'INCLUDE',
          // });                         
          if (layer.visible) {
            layer.leafletLayer.remove();
            layer.loadLayer(map);
          }          
        };
      } else if (
        layer &&
        (['importada', 'criada'].includes(layer.type) ||
          layer.getService() === 'WFS')) 
      {     
        layer.leafletLayer.eachLayer((feature) => {
          let settingsLabel = { 
            columnName: layer.selectedLabelColumn?.name,               
            feature: feature,
            fontColor: selectedFontColor,
            outlineColor: selectedOutlineColor,
            isFontBold: selectedFontBold,
            fontSize: selectedFontSize,
            direction: selectedLabelAlign,
            opacity: 0,
          };
          operator = filterOperator;   
          
          if (checkCanHideFeature(operator, feature.feature.properties[filterColumn], filterValues)) {
            applyLabelSetting({
              ...settingsLabel,
              opacity: 0,
            });
            if (layer.dataType === 'GeometryCollection') {              
              feature.options = {
                ...feature.options,
                opacity: 0, 
                fillOpacity: 0,
              }
            }
            typeof feature.setStyle !== "undefined" && feature.setStyle({ opacity: 0, fillOpacity: 0 });           
          } else if (layer.selectedLabelColumn?.name) {                          
            applyLabelSetting({
              ...settingsLabel,
              opacity: 1,
            });    
            if (!layer.statusLabelVisibility) {
              applyLabelSetting({
                ...settingsLabel,
                opacity: 0,
              });
            }        
          }
        });
        // Retorna função de reset de estilo
        return () => {          
          // layer.leafletLayer.resetStyle();          
          layer.applyFeaturesStyle(true);
          if (layer.selectedLabelColumn?.name && layer.statusLabelVisibility) {            
            let settingsLabel = {};     
            layer.leafletLayer.eachLayer((feature) => {          
              settingsLabel = {                
                columnName: layer.selectedLabelColumn.name,
                feature: feature,
                fontColor: selectedFontColor,
                outlineColor: selectedOutlineColor,
                isFontBold: selectedFontBold,
                fontSize: selectedFontSize,
                direction: selectedLabelAlign,                
                opacity: 1,
              };
              applyLabelSetting(settingsLabel);                
            });
          }
        }        
      }
    }  
  }, [
    filterColumn,
    filterValues,
    layer,
    map,
    setVisibilityLayer,
    selectedFontColor,
    selectedOutlineColor,
    selectedFontBold,
    selectedFontSize,
    selectedLabelAlign,
    operators,
    filterOperator
  ]);

  useEffect(() => {    
    const FitColunm = () => ({
      name: 'bbox',
      label: '',
      filter: false,
      sort: false,
      customRenderBody: (value, rowData, rowIndex) => {
        const FitButton = () => (
          <button
            className="svg-button"
            disabled={!value}

            onClick={(e) => {              
              e.stopPropagation(); 
              if(value._southWest && value._northEast ){
                let bounds = L.latLngBounds(value._northEast, value._southWest); 
                map.flyToBounds(bounds);
              } else{
                map.flyTo(value, 13) 
              }            
              // let bounds = L.latLngBounds(value._northEast, value._southWest); ```
              // map.flyToBounds(bounds);              
              // map.flyToBounds(value);
              // arrPoints.includes(
              //   layer ? layer.dataType : dataTabs[currentTab].layer.dataType
              // ) && layer?.type !== 'interna'
              //   ? map.flyTo(value, 13)
              //   : map.flyToBounds(value);
            }}
          >
            <Icon i="map-fit" />
          </button>
        );

        const handleEnter = () => {
          let initialLoad = false;
          let requestAllFeatures = true;
          let newInitialRequest = false;
        
          // Verifica se a camada foi configurada como 'Alto volume de dados' 
          // e se chegou no limite de solicitações e se ainda não foram solicitadas todas as feições.
          const shouldLoadAllFeatures = layer?.additionalProps.layerSize === '1'
            && rowIndex + 1 === limitForRequestAll
            && hasNewInitialRequest;
        
          if (shouldLoadAllFeatures) {
            initialLoad = true;
            newInitialRequest = true;
            setHasNewInitialRequest(false);
          }
        
          loadData(initialLoad, requestAllFeatures, newInitialRequest);
        };
        
        // if (rowIndex + 1 === data.length - loadWhen) {
        if (rowIndex + 1 === data.length) {
          return (
            <>
              <Waypoint
                onEnter={() => {                  
                  handleEnter()            
                }}
              />
              <FitButton />
            </>
          );
        } else {
          return <FitButton />;
        }
      },
      options: {
        style: { width: 30 },
      },
    });

    if (data && data.length > 0) {
      let newColumns = [];
      newColumns.push(FitColunm());
      Object.keys(data[0]).forEach((c) => {        
        if (!['envelope', 'bbox', '_feature'].includes(c)) {
          newColumns.push({
            name: c,
            label: c,
            sort: true,
            type: (data[0][c] === undefined || data[0][c] === null)
                    ? 'string'
                    : isNaN(Number(standardizeNumber(data[0][c])))
                      ? 'string'
                      : 'integer',
            display: displayedColumns ? displayedColumns.includes(c) : true,
          });
        }
      });
      setColumns(newColumns);
    }
  }, [
    data,
    page,
    layer,
    displayedColumns,
    currentTab,
    dataTabs,
    loadData,
    map,
    arrPoints,
    hasNewInitialRequest
  ]);

  useEffect(() => {
    if (dataTabs) {
      setCurrentTab(0);
    }
  }, [dataTabs]);

  useEffect(() => {
    if (currentTab !== null) {
      clearAllData();
    }
  }, [currentTab]);

  useEffect(() => {
    if (dataTabs && dataTabs.length > 0) {
      setSelectedTab(dataTabs[currentTab]?.layer?.alias);
    }
  }, [dataTabs, currentTab]);

  /**
   * Verifica se a tecla Shift está sendo pressionada
   */
  useEffect(() => {
    const onKeyDown = (e) =>
      (shiftKeyRef.current = e.keyCode === 16 ? true : shiftKeyRef.current);
    const onKeyUp = (e) =>
      (shiftKeyRef.current = e.keyCode === 16 ? false : shiftKeyRef.current);

    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('keyup', onKeyUp);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('keyup', onKeyUp);
    };
  }, []);

  /**
   * Verifica se a tecla Ctrl está sendo pressionada
   */
  useEffect(() => {
    const onKeyDown = (e) =>
      (ctrlKeyRef.current = e.keyCode === 17 ? true : ctrlKeyRef.current);
    const onKeyUp = (e) =>
      (ctrlKeyRef.current = e.keyCode === 17 ? false : ctrlKeyRef.current);

    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('keyup', onKeyUp);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('keyup', onKeyUp);
    };
  }, []);

  return (
    <Wrap tabs={Boolean(dataTabs && dataTabs.length)}>
      {loading && (
        <div className="loader">
          <CircularProgress color="inherit" />
        </div>
      )}
      <Mobile>
        {(activeView || currentTab !== null) && (
          <>
            <div className="filter-mobile-button">
              {!dataTabs && (
                <button
                  className="svg-button"
                  onClick={() =>
                    setDialogMobileOpen(
                      true,
                      'Filtro',
                      <Filter
                        columns={columns}
                        operators={operators}
                        initialValues={{
                          displayedColumns,
                          filterColumn,
                          filterValues,
                        }}
                        onFilter={onFilter}
                        onClose={() => setDialogMobileOpen(false)}
                        getDistinctValues={getDistinctValues}
                      />
                    )
                  }
                >
                  <Icon i="map-filter" width="12" height="12" />
                </button>
              )}
            </div>
            {dataTabs && dataTabs.length > 0 && (
              <div style={{ width: '55%', marginBottom: 20, marginLeft: 14 }}>
                <MultiSelect
                  name="layerTabs"
                  placeholder="Camadas"
                  type="radio"
                  onChange={(v) => setCurrentTab(v)}
                  value={currentTab}
                  data={dataTabs.map((t, i) => ({
                    label: t.layer.getTitle(),
                    value: i,
                  }))}
                  avoidMobileBehavior
                />
              </div>
            )}
          </>
        )}
      </Mobile>
      <div
        className={`attr-head`}
      >
        <h3 >Atributos - {layer?.alias}</h3>    
      </div>
        <div className="attr-table-actions active" >
          {(layer?.type === 'criada' || layer?.type === 'importada') &&            
            data && data.length ? 
            (
              <div className="actions" >
                {layer?.dataType !== 'Text' && (
                  <Tooltip title="Adicionar coluna" >
                    <button
                      className="action"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!isShowInputCell && (layer?.type === 'criada' || layer?.type === 'importada')) {
                          openPopupFormColumn(e);
                        }
                      }}
                    >
                      <Icon                   
                        i="map-layersmenu-plus"
                        width="18"
                        height="18"
                        stroke={!isShowInputCell && (layer?.type === 'criada' || layer?.type === 'importada') ? '#3c71dd' : '#797e82'}
                      />
                    </button>
                  </Tooltip>
                )}
                <Tooltip title="Salvar">
                  <button className="action" onClick={saveInputCell}>
                    <Icon
                      i="map-contextmenu-check"
                      width="18"
                      height="18"
                      fill={isShowInputCell ? '#3c71dd' : '#797e82'}
                    />
                  </button>
                </Tooltip>                
                {layer?.dataType !== 'Text' && (
                  <Tooltip title="Excluir">
                    <button
                      className="action"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!isShowInputCell) {
                          openPopupConfirmRemove();
                        }
                      }}
                    >
                      <Icon
                        i="map-trash"
                        width="18"
                        height="18"
                        stroke={
                          isEditableColumn(selectedColumn) &&
                          !isShowInputCell &&
                          (selectedColumn || layer?.selectedFeatures.length > 0)
                            ? '#3c71dd'
                            : '#797e82'
                        }
                      />
                    </button>
                  </Tooltip>
                )}
                {layer?.dataType !== 'Text' && (
                  <Tooltip title="Configurar rótulo">
                    <button
                      className="action"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!isShowInputCell && (layer.selectedLabelColumn || selectedColumn)) {
                          openPopupHideAndConfigureLabel(e);
                        }
                      }}
                    >
                      <Icon
                        i='map-configureLabel'                  
                        fill={
                          !isShowInputCell && (layer.selectedLabelColumn || selectedColumn)
                            ? '#3c71dd'
                            : '#797e82'
                        }
                      />
                    </button>
                  </Tooltip>
                )}
                {layer?.dataType !== 'Text' && (
                  <Tooltip title="Exportar Feição">
                    <button
                      className="action"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (layer.selectedFeatures.length > 0) {
                          // openPopupFormColumn(e);
                          getVetorialFeatures();
                        }
                      }}
                    >
                      <Icon
                        i="map-exportFeature"
                        width="18"
                        height="18"
                        fill={
                          layer.selectedFeatures.length > 0
                            ? '#3c71dd'
                            : '#797e82'
                        }
                      />
                    </button>
                  </Tooltip>
                )}
              </div>
            ) : (layer?.type === 'interna') ? 
              (
                <div className="actions">
                              {layer?.canDownload() ? (<Tooltip title="Exportar Feição">
                              <button
                                className="action"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (layer.selectedFeatures.length > 0) {
                                    // openPopupFormColumn(e);
                                    getVetorialFeatures();
                                  }
                                }}
                              >
                                <Icon
                                  i="map-exportFeature"
                                  width="18"
                                  height="18"
                                  fill={
                                    layer.selectedFeatures.length > 0
                                      ? '#3c71dd'
                                      : '#797e82'
                                  }
                                />
                              </button>
                            </Tooltip>) : null}
                            
                            
                          </div>
                        ) : (
                          <div className="attr-table-actions actions inactive">

                      {dataTabs  && dataTabs[currentTab] && dataTabs[currentTab]?.layer?.canDownload() ? (<Tooltip title="Exportar Feição">
                       
                      <button
                        className="action"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (dataTabs && dataTabs.length > 0) {
                            getVetorialFeatures();
                          }
                        }}
                      >
                        <Icon
                          i="map-exportFeature"
                          width="18"
                          height="18"
                          fill={
                            // verificar se na aba atual tem feições selecionadas
                            dataTabs && dataTabs[currentTab] && dataTabs[currentTab].layer.selectedFeatures?.length > 0
                              ? '#3c71dd'
                              : '#797e82'
                          }
                        />
                      </button>
                    </Tooltip>
                    ):  dataTabs  && dataTabs[currentTab]?.layer && ['importada', 'criada'].includes(dataTabs[currentTab]?.layer ? (
                      <Tooltip title='Exportar Feição'>
                        <button
                          className="action"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (dataTabs && dataTabs.length > 0) {
                              getVetorialFeatures();
                            }
                          }}
                        >
                          <Icon
                            i="map-exportFeature"
                            width="18"
                            height="18"
                            fill={
                              // verificar se na aba atual tem feições selecionadas
                              dataTabs && dataTabs[currentTab] && dataTabs[currentTab].layer.selectedFeatures?.length > 0
                                ? '#3c71dd'
                                : '#797e82'
                            }
                          />
                        </button>
                      </Tooltip>
                    ) : null)}
                </div>
              )}
          {!dataTabs && (

                <div className={`filters ${layer?.type !== 'criada' ? 'without-actions' : ''}`}>
                <Tooltip title="Limpar feições selecionadas">
                  <IconButton onClick={clearFeatureHighlights} >
                    <Icon i="map-Clear_Feature" width="21" height="20" fill={layer.selectedFeatures.length > 0 ? "#3C71DD" : ""}  />
                  </IconButton>
                </Tooltip>

                <Tooltip title={isFiltered ? "Exibir todas as feições" : "Filtrar feições selecionadas"}>
                  <IconButton onClick={() => setIsFiltered(!isFiltered)}>
                    <Icon i="map-FilterFeatures" width="18" height="18" fill={layer.selectedFeatures.length > 0 ? "#3C71DD" : ""} />
                  </IconButton>
                </Tooltip>

                <Divider 
                  orientation="vertical" 
                  flexItem 
                  style={{ backgroundColor: '#d3d3d3', height: '22px', width: '1.9px', margin: '0 12px', marginTop: 12 }} 
                />


                <Tooltip title="Limpar filtro">
                  <IconButton onClick={clearAllData} >
                    <Icon i="map-clearFilter" width="18" height="18" />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Configurar filtro">
                  <IconButton onClick={openPopOver}>
                    <Icon i="map-filter" width="18" height="18" />
                  </IconButton>
                </Tooltip>
                </div>
          )}
        </div>
      {dataTabs && dataTabs.length > 0 && (
        <div className="layer-tabs">
          <Tabs
            value={currentTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={(e, v) =>{
              setCurrentTab(v)
              const clickedTab = e.target.innerText;
              setSelectedTab(clickedTab);
            } }
          >
            {dataTabs.map((t) =>{
              return t.layer.getTitle() && (
                <Tab
                  label={t.layer.getTitle()}
                  key={t.layer.leafletLayer._leaflet_id}
                />
              )
            } )}
          </Tabs>
        </div>
      )}
      <div
        className="table-area"
      >
        {columns && data && data.length ? (
          <Table
            columns={columns}
            layer={layer}
            data={isFiltered ? filteredData : data}
            filterColumn={filterColumn}
            numberFeatures={numberFeatures}
            layerType={layer?.type}
            isEditableColumn={isEditableColumn}
            isShowInputCell={isShowInputCell}
            setIsShowInputCell={setIsShowInputCell}
            changeCell={changeCell}
            customColumnsType={customColumnsType}
            openPopupFormColumn={openPopupFormColumn}
            onSort={(column, direction) => {
              setSortColumn(column);
              setSortDirection(direction);
              if (isFiltered) {
                const sortedData = [...filteredData].sort(
                  typeof filteredData[0][`${column}`] === 'number'
                    ? sortNumerically(column, direction)
                    : sortAlphabetically(column, direction)
                );
                setFilteredData(sortedData);
              } else {
                setShouldLoad(true);
              }
            }}
            
            selectedLabelColumn={layer?.selectedLabelColumn}
     
            onClickColumn={(e, col) => {
                  if (e.target.tagName !== 'svg') {
                    if (selectedColumn && selectedColumn.name === col.name) {
                      setSelectedColumn(null);
                    } else {
                      if (isEditableColumn(col)) {
                        setSelectedColumn(col);
                      }
                    }
                  }
                
              
            }}
            isSelectedCol={(col) => {
              return selectedColumn && selectedColumn.name === col.name;
            }}
            onClickRow={async (e, row) => { 
              setReloadSelectedTab(!reloadSelectedTab);
              if (dataTabs && dataTabs.length > 0) {
                let layerTabs = dataTabs[currentTab].layer;
                let selectedLayerTab = dataTabs.find((tab) => tab.layer.getTitle() === selectedTab);
              
                if (selectedLayerTab) {
                  const layer = selectedLayerTab.layer;
                  if (layer) {
                    const isInterna = layer.type === 'interna';
                    const selectedFeatures = isInterna ? [row] : [row._feature];
                    const additionalData = isInterna ? geoJsonData : null;
                    layerTabs = dataTabs[currentTab].layer;
              
                    setLoading(true);
                    layerTabs.setSelectedFeatures(
                    selectedFeatures,
                    additionalData,
                    ctrlKeyRef.current,
                    shiftKeyRef.current,
                    true
                    );
              
                    setSelectedColumn(null);
              
                    setLayers((prevLayers) => {
                      const layerExists = prevLayers.some((existingLayer) => existingLayer.id === layer.id);
                      return layerExists ? prevLayers : [...prevLayers, layer];
                    });
              
                    if (isInterna) {
                      highlightSelectedFeature(layer? layer : dataTabs[0]?.layer)
                        .finally(() => {
                          setLoading(false);
                        })
                        .catch((error) => {
                          console.error('Erro ao destacar a feição selecionada:', error);
                          setLoading(false);
                        });
                    } else {
                      setLoading(false);
                    }
              
                    document.getSelection().removeAllRanges();
                  }
                } else {
                  console.error('Aba ou linha não encontrada:', selectedTab, row);
                }
              } else {
                console.error('dataTabs está vazio ou indefinido');
              }

             // Quando é selecinanada pela tabela de Atributos
              if (layer && layer.type !== 'interna' && layer.leafletLayer && row._feature) {
             
                  layer.setSelectedFeatures(
                    [row._feature],
                    null,
                    ctrlKeyRef.current,
                    shiftKeyRef.current,
                    true
                  );  
             

                setSelectedColumn(null);
                setLayers([...layers]);
                document.getSelection().removeAllRanges();                
              } else if (layer && layer.type === 'interna' && row) {                
                setLoading(true);
                layer.setSelectedFeatures(                  
                  [row],
                  geoJsonData,
                  ctrlKeyRef.current,
                  shiftKeyRef.current,
                  true
                );
                setSelectedColumn(null);
                setLayers([...layers]);
                highlightSelectedFeature(layer)
                .finally(() => {
                  setLoading(false);
                })
                .catch((error) => {
                  console.error('Erro ao destacar a feição selecionada:', error);
                  setLoading(false);
                });
                document.getSelection().removeAllRanges();                
              }
            }}

       
            isSelectedRow={(row) => {
          
              const checkSelectedFeature = (layer) => {
                return layer?.type === 'interna' 
                  ? layer?.selectedFeatures.some((f) => f.gid === row?.gid)
                  : layer?.selectedFeatures.includes(row?._feature);
              };
            
              if (layer) {
                return checkSelectedFeature(layer);
              }
            
              if (dataTabs && dataTabs.length > 0) {
                const currentLayer = dataTabs[currentTab]?.layer;
                return currentLayer ? checkSelectedFeature(currentLayer) : false;
              }
            
              return false;
            }}
            
            setHighlightLineInEdit={setHighlightLineInEdit}
            highlightLineInEdit={highlightLineInEdit}
          />
        ) : (
          <div className="no-data">
            {layer
              ? 'Sem dados!'
              : 'Não existem informações referentes ao ponto selecionado.'}
          </div>
        )}
      </div>
      <StyledPopoverFilter
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClosePopOver}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Filter
          columns={columns}
          layerType={layer?.type}          
          manualOperator={filterOperator}
          operators={operators}
          initialValues={{
            displayedColumns,
            filterColumn,
            filterValues,
          }}
          onFilter={onFilter}
          onClose={handleClosePopOver}
          getDistinctValues={getDistinctValues}
        />
      </StyledPopoverFilter>
      <StyledPopupFormColumn
        id="popup-form-column"
        anchorEl={anchorElFormColumn}
        open={Boolean(anchorElFormColumn)}
        onClose={handleClosePopupFormColumn}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: -10,
        }}
        transformOrigin={{
          vertical: 'top',
        }}
      >
        <div className="arrow-form-column"  style={{
          left: anchorElFormColumn?.offsetLeft + 10,
        }}></div>
        <FormColumn
          initialValues={{
            editColumn,
            editColumnType,
            displayedColumns,
            filterColumn,
            filterValues,
          }}
          onFormColumnSubmit={onFormColumnSubmit}
          onClose={handleClosePopupFormColumn}
        />
      </StyledPopupFormColumn>
      <StyledPopupHideAndConfigureLabel
        id="popup-configure-label"
        anchorEl={anchorElHideAndConfigureLabel}
        open={Boolean(anchorElHideAndConfigureLabel)}
        onClose={handleClosePopupFormHideAndConfigureLabel}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
        }}
      >
        <div className="arrow-configure-label"></div>
        <HideAndConfigureLabel
          initialValues={{
            selectedFontColor,
            selectedOutlineColor,
            selectedFontBold,
            selectedFontSize,
            selectedLabelAlign,
          }}
          onFormConfigureLabel={onFormConfigureLabel}
          layer={layer}
          selectedColumn={selectedColumn}
          isShowInputCell={isShowInputCell}
          setEditColumn={setEditColumn}
          setEditColumnType={setEditColumnType}
          onClose={handleClosePopupFormHideAndConfigureLabel}
        />
      </StyledPopupHideAndConfigureLabel>
      <CustomModalSaveAsLayer
        title="Salvar Camada"
        saveModalOpen={saveModalOpen}
        handleCloseSaveModal={handleCloseSaveModal}
        formik={formik}
        SliderColorPicker={<SliderColorPicker
          geometryType={
            arrPolygons.includes(dataTabs && dataTabs.length > 0
              // Se dataTabs está definido e não está vazio, verifica se currentTab está dentro do intervalo válido
              ? (dataTabs[currentTab] && dataTabs[currentTab].layer?.dataType)
              // Caso contrário, verifica se layer está definido e acessa sua propriedade dataType
              : layer?.dataType)
              ? 'Polygon'
              : arrLines.includes(dataTabs && dataTabs.length > 0
                // Se dataTabs está definido e não está vazio, verifica se currentTab está dentro do intervalo válido
                ? (dataTabs[currentTab] && dataTabs[currentTab].layer?.dataType)
                // Caso contrário, verifica se layer está definido e acessa sua propriedade dataType
                : layer?.dataType)
              ? 'Line'
              : 'Point'
          }
          autoSelect={false}
          selectedSymbology={formik.values.layerStyle}
          onSelect={(style) => formik.setFieldValue('layerStyle', style)}
        />
    }
      />
    </Wrap>
  );
};

AttributeTable.propTypes = {
  /** Camada a qual se está visualizando os dados, apenas na visualização de uma unica camada */
  layer: PropTypes.instanceOf(Layer),
  /** Instância do mapa leaflet */
  map: PropTypes.instanceOf(L.Map).isRequired,
  /** Define se a view está ativa, usado apenas no mobile. DEPRECATED */
  activeView: PropTypes.bool,
  /** Array contendo multiplas camadas, e seus respectivos dados. Usado no **Identificar Feição** */
  dataTabs: PropTypes.array,
  /** Função de callback para a alteração do cursor do mouse. function(preset) */
  changeCursor: PropTypes.func,
};

AttributeTable.properties = {
  ignore: true,
};

export default AttributeTable;
